<script>
  import category_sort_options from '/srv/web/wyvr/html/releases/58819/gen/client/shop/config/category_sort_options.js?1733898724659';
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  export let sort_by = "position";
  export let asc = true;

  function toggleAsc() {
    asc = !asc;
  }
</script>

<section class="component-filter-sort">
  <label for="sorting">Sortierung</label>
  <select bind:value={sort_by} on:change={() => dispatch("change", sort_by)}>
    {#each category_sort_options as option}
      <option value={option}>{window.__("category_sort." + option)}</option>
    {/each}
  </select>

  {#if asc}
    <button
      class="icon-up"
      on:click={toggleAsc}
      title={window.__(asc ? "category_sort.asc" : "category_sort.desc")}
    >
      
    </button>
  {:else}
    <button
      class="icon-down"
      on:click={toggleAsc}
      title={window.__(asc ? "category_sort.asc" : "category_sort.desc")}
    >
    </button>
  {/if}
</section>


<style>section {
    display: flex;
    justify-content: end;
    padding: 0.5rem 0;
    gap: 0.2rem;
}
  label {
    font-size: 16px !important;
  }
  section {
    width: 100%;
    justify-content: start;
    padding-top: 15px;
    padding-bottom: 15px;
    margin-bottom: 10px;
  }
  label {
    margin-right: 15px;
  }
  button {
    background: none;
    border: none;
    padding: 8px 16px;
    cursor: pointer;
    outline: none;
  }
</style>